import React, { useEffect } from 'react'
import { NotificationsProps } from './Notifications.types'
import { User } from 'utilities'
import {
  IconErrorSmall,
  IconInfoSmall,
  IconNotifications,
  IconSuccessSmall,
  IconWarningSmall
} from 'assets'
import { observer } from 'mobx-react-lite'
import { inject } from 'mobx-react'
import { NOTIFICATIONS_STORE } from 'store'
import { HeaderNotifications } from '@touche-lts/panel-ui/dist'

const POLL_INTERVAL_MS = 15000

const NotificationsComponent = (props: NotificationsProps) => {
  const {
    className,
    style,
    [NOTIFICATIONS_STORE]: {
      getNotifications,
      newNotificationsCount,
      userNotificationsList,
      markNotificationSeen
    }
  } = props

  useEffect(() => {
    let intervalId: number | undefined

    const start = () => {
      if (intervalId !== undefined) return
      if (!User.isAuthenticated()) return
      getNotifications()
      intervalId = window.setInterval(getNotifications, POLL_INTERVAL_MS)
    }

    const stop = () => {
      if (intervalId !== undefined) {
        window.clearInterval(intervalId)
        intervalId = undefined
      }
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        start()
      } else {
        stop()
      }
    }

    if (document.visibilityState === 'visible') {
      start()
    }
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
      stop()
    }
  }, [getNotifications])

  return (
    <HeaderNotifications
      className={className}
      style={style as any}
      disabled={!User.isAuthenticated()}
      iconNotifications={IconNotifications as any}
      markNotificationSeen={markNotificationSeen}
      newNotificationsCount={newNotificationsCount}
      userNotificationsList={userNotificationsList}
      typeIcons={{
        ERROR: IconErrorSmall as any,
        INFO: IconInfoSmall as any,
        OK: IconSuccessSmall as any,
        WARNING: IconWarningSmall as any
      }}
    />
  )
}

const Notifications = inject('NOTIFICATIONS_STORE')(
  observer(NotificationsComponent)
)
export { Notifications }
